export default "__VITE_ASSET__CKoWWkXj__"